import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriaCreateInterface } from "../../interfaces/categoriaInterfaces/CategoriaCreate.interface";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import apiClient from "@/clients/apiClient";
import { ProveedorCreateInterface } from "../../interfaces/proveedorInterfaces/ProveedorCreate.interface";
import { ProveedorInterface } from "../../interfaces/proveedorInterfaces/Proveedor.interface";

export async function UpdateProveedoroAction(
    categoriaId: string,
    updateData: Partial<ProveedorCreateInterface>
): Promise<ApiResponse<ProveedorInterface>> {
    const { data } = await apiClient.patch<ProveedorInterface>(  
        `gpProveedoresProducto/${categoriaId}`,
        updateData
    );
    return {
        status: 200,
        data,
        message: "Proveedor de producto actualizada correctamente",
    };

}